import styled from 'styled-components';

import { FormWrapper as FormWrapperBase } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import { Button as ButtonBase } from 'components/uikit/Button/Button';
import { DatePicker } from 'components/modules/Insurance/components/DatePicker/DatePicker';
import { MAX_DATE, MIN_DATE } from 'components/modules/Insurance/Insurance.constants';
import { VALUE_FIELDS } from 'store/carInstance/constants';

export const ButtonsWrapper = styled.div`
  display: flex;
  column-gap: 2px;

  box-sizing: border-box;
  padding: 2px;

  background-color: var(--color-grey-10_10);

  border-radius: 12px;

  width: fit-content;
`;

export const Button = styled(ButtonBase).attrs(({ active }) => {
  return { size: 'm', theme: active ? '5' : '2' };
})`
  --button-height: 40px;

  min-width: 178px;
`;

export const FormWrapper = styled(FormWrapperBase)``;

export const CarIssueDatePicker = styled(DatePicker).attrs({
  label: 'Дата покупки',
  name: VALUE_FIELDS.CAR_ISSUE_DATE,
  maxDate: MAX_DATE,
  minDate: MIN_DATE,
})`
  grid-column: ${({ full }) => {
    let result = 'auto';

    if (full) {
      result = '1 / 3';
    }

    return result;
  }};
`;
